import styled from 'styled-components';
import { ValidHex } from '@lendi-ui/commons/colours';
import { Body as LuiBody, Heading as LuiHeading, Link as LuiLink } from '@lendi-ui/typography';

export const Body = styled(({ color, ...otherProps }) => <LuiBody {...otherProps} />)`
  color: ${({ color }: { color: ValidHex }) => color};
`;
export const Link = styled(({ color, ...otherProps }) => <LuiLink {...otherProps} />)`
  color: ${({ color }: { color: ValidHex }) => color};
`;
export const Heading = styled(({ color, ...otherProps }) => <LuiHeading {...otherProps} />)`
  color: ${({ color }: { color: ValidHex }) => color};
`;
